import { render } from "./TopHeader.vue?vue&type=template&id=13fe46e9&scoped=true"
const script = {}

import "./TopHeader.vue?vue&type=style&index=0&id=13fe46e9&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13fe46e9"]])

export default __exports__